var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop } from "vue-property-decorator";
import { PageService } from '~/utils/page.service';
import { RobCaseService } from '~/services/domain-service/rob-case.service.ts';
import { SortService } from '~/utils/sort.service';
var FollowUpRecordCommon = /** @class */ (function (_super) {
    __extends(FollowUpRecordCommon, _super);
    function FollowUpRecordCommon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.roleDataSet = [];
        return _this;
    }
    /**
     * 首次打开调用
     */
    FollowUpRecordCommon.prototype.update = function () {
        var _this = this;
        this.robCaseService.queryFollowupRecords(this.followUpId, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.roleDataSet = data;
        });
    };
    __decorate([
        Dependencies(SortService)
    ], FollowUpRecordCommon.prototype, "sortService", void 0);
    __decorate([
        Dependencies(RobCaseService)
    ], FollowUpRecordCommon.prototype, "robCaseService", void 0);
    __decorate([
        Dependencies(PageService)
    ], FollowUpRecordCommon.prototype, "pageService", void 0);
    __decorate([
        Prop()
    ], FollowUpRecordCommon.prototype, "followUpId", void 0);
    FollowUpRecordCommon = __decorate([
        Component({
            components: {}
        })
    ], FollowUpRecordCommon);
    return FollowUpRecordCommon;
}(Vue));
export default FollowUpRecordCommon;
